import FormSelector from '../elements/FormSelector';

const FormIframe = ({ form }) => {
   return <FormSelector form={form} />;
};

export default FormIframe;
